import { CheckoutFeedbackQuestionProjection } from "../../../projection/checkoutFeedback/checkoutFeedback";
import { CheckoutFeedbackQuestionType } from "../../../projection/checkoutFeedback/checkoutFeedback.constants";

const checkoutFeedbackDefinition: CheckoutFeedbackQuestionProjection[] = [
  {
    id: "efe07b97-f6fb-4b6a-ba92-b68519320b2c",
    translationKey: "checkout_question.selection.question",
    type: CheckoutFeedbackQuestionType.HOST_SELECT,
    metadata: {
      placeholder: "checkout_question.selection.placeholder",
      showCondition: [],
    },
    children: [
      {
        id: "68c0bb98-b00a-4b86-af43-528fe903cb69",
        type: CheckoutFeedbackQuestionType.ICON,
        metadata: {
          icon: "checkout_feedback.icon.bad",
        },
      },
      {
        id: "85e84a77-461c-41e6-8544-95b5294d0b80",
        type: CheckoutFeedbackQuestionType.ICON,
        metadata: {
          icon: "checkout_feedback.icon.regular",
        },
      },
      {
        id: "29441d25-8d9f-471e-a13e-a03f61c88091",
        type: CheckoutFeedbackQuestionType.ICON,
        metadata: {
          icon: "checkout_feedback.icon.good",
        },
      },
    ],
  },
  {
    id: "6a6d3878-5561-412c-96f3-7ed79ee587bb",
    translationKey: "checkout_question.experience.question",
    type: CheckoutFeedbackQuestionType.HOST_SELECT,
    metadata: {
      placeholder: "checkout_question.experience.placeholder",
      showCondition: [],
    },
    children: [
      {
        id: "a3d937b6-7499-4a3c-86bf-5c0af9ab2e23",
        type: CheckoutFeedbackQuestionType.ICON,
        metadata: {
          icon: "checkout_feedback.icon.bad",
        },
      },
      {
        id: "7970edd3-fb5c-42d3-afe3-ce31bcbb856c",
        type: CheckoutFeedbackQuestionType.ICON,
        metadata: {
          icon: "checkout_feedback.icon.regular",
        },
      },
      {
        id: "bab3d4f9-0227-4550-a53f-3c125d68429c",
        type: CheckoutFeedbackQuestionType.ICON,
        metadata: {
          icon: "checkout_feedback.icon.good",
        },
      },
    ],
  },
  {
    id: "a1acdb2d-62c8-467f-b7cc-dc24d967290c",
    translationKey: "checkout_question.personalshopper.question",
    type: CheckoutFeedbackQuestionType.HOST_SELECT,
    metadata: {
      showCondition: ["68c0bb98-b00a-4b86-af43-528fe903cb69"],
      placeholder: "checkout_question.personalshopper.placeholder",
    },
    children: [
      {
        id: "cce7851c-92c7-461b-8dcb-903c5de59ed1",
        translationKey: "checkout_question.personalshopper.yes",
        type: CheckoutFeedbackQuestionType.BUTTON,
      },
      {
        id: "4bf8f27d-669b-4d36-8d39-b5599c671816",
        translationKey: "checkout_question.personalshopper.no",
        type: CheckoutFeedbackQuestionType.BUTTON,
      },
    ],
  },
  {
    id: "ce3e8d57-5eea-4dd3-bef4-2e811a143612",
    translationKey: "checkout_question.comment.question",
    type: CheckoutFeedbackQuestionType.HOST_TEXTAREA,
    metadata: {
      showCondition: [],
    },
    children: [
      {
        id: "1123a37d-bc00-43a4-9d28-cee1dfaf356c",
        translationKey: "checkout_question.comment.question",
        type: CheckoutFeedbackQuestionType.TEXTAREA,
        metadata: {
          placeholder: "checkout_question.comment.placeholder",
        },
      },
    ],
  },
];

export { checkoutFeedbackDefinition };
